<template>
    <div class="endless-table full-height">
        <!-- BEGIN FLOAT HEAD TABLE -->
        <div class="table-toolbar">
            <div class="left">
                Records:
                <span class="text-left" v-if="count && !isLoading">
                    <b>{{ count }}</b></span
                                      >
                <i v-if="isLoading" class="fa fa-lg fa-circle-o-notch fa-spin"></i>
            </div>
            <div class="right">
                <ul class="nav navbar-nav navbar-left">

                    <li v-if="isAdmin && !readOnly">
                        <button
                            type="button"
                            class="btn btn-icon"
                            v-on:click.prevent="$emit('showColumnPicker')"
                            v-tooltip.bottom="'Pick columns'">
                            <i class="fa fa-lg fa-columns"></i>
                        </button>
                    </li>
                    <li>
                        <button
                            v-if="!readOnly"
                            type="button"
                            class="btn btn-icon"
                            v-on:click.prevent="$emit('leadsDownload')"
                            v-tooltip.bottom="'Download leads'">
                            <i class="fa fa-lg fa-download"></i>
                        </button>
                    </li>
                </ul>
                <input v-if="!readOnly" v-model="query_text" type="text" placeholder="Search ..." />
            </div>
        </div>
        <transition name="fade">
            <div id="wrapper" class="wrapper small" v-show="isVisible">
                <table class="table table-bordered table-striped leads-queue-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th
                                v-for="(item, $index) in pickedColumns"
                                class="sorting"
                                v-on:click="sort(item)"
                                v-bind:class="{
        		              'sorting_asc': orderBy === item.id && !orderAsc,
        		              'sorting_desc': orderBy === item.id && orderAsc
                                      }">
                                <span v-if="item.field_type == 'S'" class="label label-primary">LS</span> {{item.name}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="th not-visible">
                            <td></td>
                            <td v-for="(item, $index) in pickedColumns">
                                <div><span v-if="item.field_type == 'S'" class="label label-primary">LS</span> {{item.name}}</div>
                            </td>
                        </tr>
                        <tr v-for="row in rows" :key="row.id">
                            <td class="text-center">
                                <button class="btn btn-link" @click="leadId = row.id">
                                    <i class="fa fa-info" style="padding-right: 0"></i>
                                </button>
                            </td>

                            <td v-for="fieldValue in row.data">
                                <div class="cell-inner">{{ fieldValue }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </transition>
        <!-- END ENDLESS TABLE -->

        <!-- BEGIN LEAD DETAIL -->
        <lead-data-modal
            v-if="leadId"
            :leadId="leadId"
            @close="leadId = ''"
        ></lead-data-modal>
        <!-- END LEAD DETAIL -->
    </div>
</template>
<script>
// http://mkoryak.github.io/floatThead/#examples

import Vue from "vue";
import LeadDataModal from "components/modals/LeadDataModal";

var _ = require("lodash");

 export default {
     name: 'endlesstable',
     components: {
         'lead-data-modal': LeadDataModal
     },

     props: {
         readOnly: {
             type: Boolean,
             default: false
         },
       showColumnPicker: Boolean,

         isAdmin: Boolean,
         dashboardId: String,
         datesRange: {
             type: Object,
             default () {
                 return {"from": null, "to": null, "date_field": null}
             }
         },
         rules: Object,
         pickedColumns: Array,
         showLeadsTable: Boolean
     },
     data () {
       return {
         table: {},
         orderBy: null,
         orderAsc: false,
         current_page: 1,
         rows: [],
         headerRow: [],
         leadId: '',
         query_text: null,
         isVisible: this.showLeadsTable,
         isLoading: false,
         count: null,
         query: {
	       page: 1,
	         page_size: 50,
	         dashboard_id: this.dashboardId,
	         q: null
         }
         };
          },

     created() {
         var self = this;
         this.$nextTick(function () {
             var wrapper = $('#wrapper');
             var windowH = $(window).height();
             // Each time the user scrolls
             self.reflow();

             wrapper.scroll(function() {
	         if (wrapper[0].scrollHeight - wrapper.scrollTop() <= wrapper.outerHeight() + 100) {
	             var nextPage = true;
	             BUS.$emit('refreshLeads', null, nextPage);
	         }
             });

             this.setTableHeader(this.pickedColumns);
             BUS.$on('refreshLeads', this.fetchLeads);
             BUS.$on('toggleSidebar', this.reflow);
         });
     },
     beforeDestroy() {
         this.$table.floatThead('destroy');
     },
     computed: {
         dates_range () {
             return this.datesRange;
         },
         $table () {
             return $('table.leads-queue-table');
         }
     },
     watch: {
         showLeadsTable: {
             handler: function (val, oldVal) {
                 var self = this;
                 self.isVisible = val;
                 if (!self.isVisible) {
                     self.$table.floatThead('destroy');
                 }
                 else {
                     var wrapper = $('#wrapper');
                     var windowH = $(window).height();

                     //wrapper.height(windowH - 400);

                     // Each time the user scrolls
                     self.reflow();

                     wrapper.scroll(function() {
	                 if (wrapper[0].scrollHeight - wrapper.scrollTop() <= wrapper.outerHeight() + 100) {
	                     var nextPage = true;
	                     BUS.$emit('refreshLeads', null, nextPage);
	                 }
                     });
                 }
             },
             deep: true
         },
         dashboardId: {
             immediate: true,
             handler: function (val) {
                 this.fetchLeads();
             }
         },
         datesRange: {
             immediate: true,
             handler: function (val, oldVal) {
	         this.fetchLeads();
             },
             deep: true
         },
         pickedColumns: {
             handler: function (val, oldVal) {
	         // Refreshing the table to paint the columns correctly
	         this.setTableHeader(val);
	         this.fetchLeads();
             },
             deep: true
         },
         rules: {
             handler: function (val, oldVal) {
                 // This is not vuey at all!
                 this.fetchLeads();
             },
             deep: true
         },
         query_text: {
             handler: _.debounce(function (val, oldVal) {
                 var q = val.trim() || null;
                 this.query.q = q
                 this.$emit('do-text-search', q);
                 this.fetchLeads();
             }, 150)
         }
     },
     mounted () {

     },
     methods: {
         setTableHeader(fields) {
             if (this.$table && this.$table.floatThead) {
	         this.$table.floatThead('reflow');
             }
         },
         reflow() {
             var self = this;
             self.$table.floatThead('destroy');

             self.$nextTick(() => {
                 if (self.isVisible) {
                     self.$table.floatThead({
	                 position: 'absolute',
	                 scrollContainer: true
                     });
                     self.$table.floatThead('reflow');
                 }
             });
         },
         handleNewLeads(leads, page) {
             var self = this;

             if (page == 1) {
	         self.rows = [];
             }

             self.populateRows(leads);

             // On document ready
             // Refreshing the table to paint the columns correctly
             self.$table.trigger('reflow');
             // $(document).ready(function() {
             //   self.$table.floatThead('reflow');
             // });
         },
         populateRows (rowsArr) {
             var self = this;
             for (var index in rowsArr) {
	         var row = rowsArr[index];
	         var obj = this.populateRow(row);
	         var populated = jQuery.extend(true, {}, obj);
	         self.rows.push(populated);
             }
         },
         populateRow (row) {
             return {
                 id: row.id,
                 data: this.pickedColumns.map(c => {
                     if (c.data_type.id == 'DateField') {
                         return this.$options.filters.formatTimestamp(row['data'][c.id]) || '';
                     }
                     return row['data'][c.id] || '';
                 })
             };
         },
         sort (item) {
             var nextPage = false;
             var itemVal = item.id;

             if (itemVal === this.orderBy && this.orderAsc) {
	         this.orderAsc = false;
             }
             else {
	         this.orderAsc = true;
             }

             this.orderBy = itemVal;

             BUS.$emit('refreshLeads', {
	         asc: (this.orderBy === itemVal) ? !this.orderAsc : true,
	         order_by: itemVal
             }, nextPage)
         },
         fetchLeads: _.debounce(function (params, nextPage, success) {
             if (nextPage) {
	         this.query.page += 1;
             }
             else {
	         this.query.page = 1;
             }
             if (params) {
	         if (params.order_by !== undefined) {
	             this.query.order_by = params.order_by;
	         }
	         if (params.asc !== undefined) {
	             this.query.asc = params.asc;
	         }
             }
             var queryRequest = Vue.leadscorz.deep_clone(this.query);
             queryRequest.c = JSON.stringify(this.rules);

             if (!this.dashboardId) {
                 queryRequest.cols = JSON.stringify(this.pickedColumns.map(c => c.id));
             }

             for (var k in this.datesRange) {
                 if (this.datesRange[k]) {
                     queryRequest[k] = this.datesRange[k];
                 }
             }

             var self = this;
             self.isLoading = true;
             API.leads.getList(queryRequest)
	        .then(function (response) {
	            self.handleNewLeads(response.data.leads, self.query.page);
                    self.count = response.data.count;
	            self.isLoading = false;
                },function () {
                    self.isLoading = false;

                    self.count = null;
                });
         }, 50),
     }
 };

</script>
<style lang="scss">
@import "./static/css/_variables.scss";

.wrapper {
  overflow: auto;
  position: relative;
}
.leads-queue {
  border-radius: 0px !important;
}
.wrapper.small {
  height: 100%;
  width: 100%;
}
.not-visible {
  visibility: hidden;
}
tr.not-visible,
tr.not-visible td {
  padding: 0 !important;
  height: 0 !important;
  line-height: 0 !important;
}
tr.not-visible td div {
  display: inline-block;
  white-space: nowrap;
  margin-right: 42px;
  font-weight: 500;
  font-size: 16px;
  line-height: 0;
}
.endless-table th,
.endless-table .th {
  background: #f38c3d;
  color: #fff;
}
.floatThead-wrapper {
  height: calc(100% - 45px);
}
.endless-table td > .btn {
  text-align: center;
  padding: 0px 6px;
}
.sorting:hover {
  cursor: pointer;
}

table.leads-queue-table {
  font-family: "Roboto Mono", "Inconsolata", monospace;
}

.cell-inner {
  height: 1.4em;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}

.table-toolbar .fa-spin {
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// EndlessTable.vue?26aa6681